<template>
  <div>
    <div class="col secondary-footer" style="">
      <div class="container">
        <div class="row" style="padding: 20px">
          <h5><strong>About Hireclap</strong></h5>
          <p>Hireclap is the largest video resume based job site in India. More than 3 million+ jobseekers registered with Hireclap, over 5000 companies used our recruitment services to hire candidates for its entry-level / fresher hiring and the database is growing daily.</p>
          <p>Job seekers can upload their 2-minute video resume -Visume, to showcase who they are and why a company should hire them. A video profile is an opportunity to describe yourself to a company beyond your resume.</p>
          <p>Companies can post free jobs and shortlist best matching candidates from video profiles. Recruiters can use the latest recruitment tools, reach out to the largest pool of active job seekers and make the data driven hiring decisions virtually.</p>
        </div>
        <div class="card-deck">
          <div class="card" style="background: transparent;border: none;">
            <div class="card-body">
              <h5 class="card-title"><strong>Need help?</strong></h5>
              <a href="mailto:recruit@hireclap.com"><h6>recruit@hireclap.com</h6></a>
              <h6>+91 9037 156 256</h6>
              <!-- <div class="btn footerBtn mt-7">Contact  Us</div> -->
              <div class="btn mt-7"><a href="/contact-us" class="footerBtn btn px-2" target="_blank">Contact  Us</a></div>

              <!-- <a class="btn footerBtn mt-7" href="/contact-us">Contact  Us</a> -->

            <div class="row gap20"></div>                        
          </div>
        </div>
        <div class="card" style="background: transparent;border: none;">
          <div class="card-body">
            <h5 class="card-title"><strong>Candidate zone</strong></h5>
            <p class="card-text">
              <a class="flink" href="/jobseeker/register" target="_blank">Post visume</a>
              <a class="flink" href="/" target="_blank">Candidate services</a>
            </p>
          </div>
        </div>
        <div class="card" style="background: transparent;border: none;">
          <div class="card-body">
            <h5 class="card-title"><strong>Employer zone</strong> </h5>
            <p class="card-text">
              <a class="flink" href="/recruit/post-job" target="noopener">Free job posting</a>
              <a class="flink" target="_blank" href="/">Recruitment package</a>
              <a class="flink" target="_blank" href="/">Resume search</a>
              <a class="flink" target="_blank" href="/">End to end consulting</a>
              <a class="flink" target="_blank" href="https://www.assessengine.com/">Online assessment <span><v-icon style="color:#007bff" size="14px">{{$icons.starCircle}}</v-icon></span></a>
              <a class="flink" target="_blank" href="/">Application management system</a>
              <a class="flink" target="_blank" href="/recruit/package-pricing">Pricing</a>
              <a class="flink" target="_blank" href="/skillhire">Skillhire</a>
            </p>
          </div>
        </div>
        <div class="card" style="background: transparent;border: none;">
          <div class="card-body">
            <h5 class="card-title"><strong>Institute zone</strong></h5>
            <p class="card-text">
              <a class="flink" target="_blank" href="/institutes">List your institute</a>
              <!-- <a class="flink" target="_blank" href="/training-institutes">Institute list</a> -->
              <!-- <a class="flink" target="_blank" href="/training-courses">Course list</a> -->
              <a class="flink" target="_blank" href="/">Virtual campus placement</a>
              <a class="flink" target="_blank" href="/">Virtual placement cell (VPCell)</a>
            </p>
          </div>
        </div>
        <div class="card" style="background: transparent;border: none;">
          <div class="card-body">
            <h5 class="card-title"><strong>College zone</strong></h5>
            <p class="card-text">
              <a class="flink" target="_blank" href="/colleges/register">List your college</a>
              <!-- <a class="flink" target="_blank" href="/view-colleges">College list</a> -->
              <a class="flink" target="_blank" href="/">Campus placements </a>
              <a class="flink" target="_blank" href="/">Placement preparation </a>
              <a class="flink" target="_blank" href="/">Mock assessments </a>
            </p>
          </div>
        </div>
      </div>
    </div> 
    </div>

    <div class="col site-links secondary-footer">
      <div class="container">
        <div class="footer-section">
          <h3><a href="/jobs-by-cities" target="noopener" style="color:#333 !important;"><strong>Jobs by city</strong></a></h3>
          <p class="card-text row m-0">
            <a class="flink col-lg-3" href="/jobs-in-ahmedabad" target="noopener">Jobs in Ahmedabad</a>
            <a class="flink col-lg-3" href="/jobs-in-hyderabad" target="noopener">Jobs in Hyderabad</a>
            <a class="flink col-lg-3" href="/jobs-in-pune" target="noopener">Jobs in Pune</a>
            <a class="flink col-lg-3" href="/jobs-in-lucknow" target="noopener">Jobs in Lucknow</a>
            <a class="flink col-lg-3" href="/jobs-in-bangalore" target="noopener">Jobs in Bangalore</a>
            <a class="flink col-lg-3" href="/jobs-in-kolkata" target="noopener">Jobs in Kolkata</a>
            <a class="flink col-lg-3" href="/jobs-in-gurgaon" target="noopener">Jobs in Gurgaon</a>
            <a class="flink col-lg-3" href="/jobs-in-bhopal" target="noopener">Jobs in Bhopal</a>
            <a class="flink col-lg-3" href="/jobs-in-chennai" target="noopener">Jobs in Chennai</a>
            <a class="flink col-lg-3" href="/jobs-in-kochi" target="noopener">Jobs in Kochi</a>
            <a class="flink col-lg-3" href="/jobs-in-noida" target="noopener">Jobs in Noida</a>
            <a class="flink col-lg-3" href="/jobs-in-indore" target="noopener">Jobs in Indore</a>
            <a class="flink col-lg-3" href="/jobs-in-delhi" target="noopener">Jobs in Delhi</a>
            <a class="flink col-lg-3" href="/jobs-in-mumbai" target="noopener">Jobs in Mumbai</a>
            <a class="flink col-lg-3" href="/jobs-in-jaipur" target="noopener">Jobs in Jaipur</a>
            <a class="flink col-lg-3" href="/jobs-in-patna" target="noopener">Jobs in Patna</a>
            
            <!-- Collapsible section -->
            <b-collapse id="moreCities" class="mx-0 mt-0 row mb-3">
              <a class="flink col-lg-3" href="/jobs-in-nagpur" target="noopener">Jobs in Nagpur</a>
              <a class="flink col-lg-3" href="/jobs-in-meerut" target="noopener">Jobs in Meerut</a>
              <a class="flink col-lg-3" href="/jobs-in-mysore" target="noopener">Jobs in Mysore</a>
              <a class="flink col-lg-3" href="/jobs-in-vadodara" target="noopener">Jobs in Vadodara</a>
              <a class="flink col-lg-3" href="/jobs-in-warangal" target="noopener">Jobs in Warangal</a>
              <a class="flink col-lg-3" href="/jobs-in-gwalior" target="noopener">Jobs in Gwalior</a>
              <a class="flink col-lg-3" href="/jobs-in-udaipur" target="noopener">Jobs in Udaipur</a>
              <a class="flink col-lg-3" href="/jobs-in-rajkot" target="noopener">Jobs in Rajkot</a>
              <a class="flink col-lg-3" href="/jobs-in-salem" target="noopener">Jobs in Salem</a>
              <a class="flink col-lg-3" href="/jobs-in-coimbatore" target="noopener">Jobs in Coimbatore</a>
              <a class="flink col-lg-3" href="/jobs-in-visakhapatnam" target="noopener">Jobs in Visakhapatnam</a>
              <a class="flink col-lg-3" href="/jobs-in-bhubaneswar" target="noopener">Jobs in Bhubaneswar</a>
              <a class="flink col-lg-3" href="/jobs-in-nellore" target="noopener">Jobs in Nellore</a>
              <a class="flink col-lg-3" href="/jobs-in-surat" target="noopener">Jobs in Surat</a>
              <a class="flink col-lg-3" href="/jobs-in-kottayam" target="noopener">Jobs in Kottayam</a>
              <a class="flink col-lg-3" href="/jobs-in-vijayawada" target="noopener">Jobs in Vijayawada</a>
              <a class="flink col-lg-3" href="/jobs-in-jodhpur" target="noopener">Jobs in Jodhpur</a>
              <a class="flink col-lg-3" href="/jobs-in-chandigarh" target="noopener">Jobs in Chandigarh</a>
              <a class="flink col-lg-3" href="/jobs-in-kanpur" target="noopener">Jobs in Kanpur</a>
              <a class="flink col-lg-3" href="/jobs-in-srinagar" target="noopener">Jobs in Srinagar</a>
              <a class="flink col-lg-3" href="/jobs-in-mangalore" target="noopener">Jobs in Mangalore</a>
              <a class="flink col-lg-3" href="/jobs-in-nasik" target="noopener">Jobs in Nasik</a>
              <a class="flink col-lg-3" href="/jobs-in-varanasi" target="noopener">Jobs in Varanasi</a>
              <a class="flink col-lg-3" href="/jobs-in-vellore" target="noopener">Jobs in Vellore</a>
              <a class="flink col-lg-3" href="/jobs-in-amritsar" target="noopener">Jobs in Amritsar</a>
              <a class="flink col-lg-3" href="/jobs-in-ranchi" target="noopener">Jobs in Ranchi</a>
              <a class="flink col-lg-3" href="/jobs-in-guwahati" target="noopener">Jobs in Guwahati</a>
              <a class="flink col-lg-3" href="/jobs-in-kota" target="noopener">Jobs in Kota</a>
              <a class="flink col-lg-3" href="/jobs-in-jalandhar" target="noopener">Jobs in Jalandhar</a>
              <a class="flink col-lg-3" href="/jobs-in-thiruvananthapuram" target="noopener">Jobs in Thiruvananthapuram</a>
              <a class="flink col-lg-3" href="/jobs-in-jabalpur" target="noopener">Jobs in Jabalpur</a>
              <a class="flink col-lg-3" href="/jobs-in-agra" target="noopener">Jobs in Agra</a>
            </b-collapse>
          </p>
          
          <!-- View More/Less button -->
          <div class="text-center mt-3">
            <p v-b-toggle.moreCities @click="toggleCities">
              {{ showMoreCities ? 'View Less' : 'View More Cities' }}
              <i class="fas" :class="showMoreCities ? 'fa-chevron-up' : 'fa-chevron-down'"></i>
            </p>
          </div>
        </div>
        <div class="footer-section">
          <h3><a href="/jobs-by-category" target="noopener" style="color:#333 !important;"><strong>Jobs by Category</strong></a></h3>
          <p class="card-text row m-0">
            <!-- Initial visible categories -->
            <a class="flink col-lg-3" href="/government-jobs-vacancies" target="noopener">Government Jobs</a>
            <a class="flink col-lg-3" href="/sales-and-marketing-jobs-vacancies" target="noopener">Sales and Marketing Jobs</a>
            <a class="flink col-lg-3" href="/bpo-jobs-vacancies" target="noopener">BPO Jobs</a>
            <a class="flink col-lg-3" href="/internship-jobs-vacancies" target="noopener">Internship Jobs</a>
            <a class="flink col-lg-3" href="/work-from-home-jobs-vacancies" target="noopener">Work from Home Jobs</a>
            <a class="flink col-lg-3" href="/mba-jobs-vacancies" target="noopener">MBA Jobs</a>
            <a class="flink col-lg-3" href="/walkin-jobs-vacancies" target="noopener">Walkin Jobs</a>
            <a class="flink col-lg-3" href="/part-time-jobs-vacancies" target="noopener">Part Time Jobs</a>
            <a class="flink col-lg-3" href="/it-software-jobs-vacancies" target="noopener">IT/Software Jobs</a>
            <a class="flink col-lg-3" href="/management-jobs-vacancies" target="noopener">Management Jobs</a>
            <a class="flink col-lg-3" href="/digital-marketing-jobs-vacancies" target="noopener">Digital Marketing Jobs</a>
            <a class="flink col-lg-3" href="/core-technical-jobs-vacancies" target="noopener">Core Technical Jobs</a>
            <a class="flink col-lg-3" href="/bank-jobs-vacancies" target="noopener">Bank Jobs</a>
            <a class="flink col-lg-3" href="/railways-jobs-vacancies" target="noopener">Railways Jobs</a>
            <a class="flink col-lg-3" href="/defence-jobs-vacancies" target="noopener">Defence Jobs</a>
            <a class="flink col-lg-3" href="/finance-jobs-vacancies" target="noopener">Finance Jobs</a>

            <!-- Collapsible section -->
            <b-collapse id="moreCategories" class="mt-0 mx-0 row mb-3">
              <a class="flink col-lg-3" href="/health-care-jobs-vacancies" target="noopener">Health Care Jobs</a>
              <a class="flink col-lg-3" href="/computer-operator-jobs-vacancies" target="noopener">Computer Operator Jobs</a>
              <a class="flink col-lg-3" href="/dream-jobs-5-lpa-jobs-vacancies" target="noopener">Dream Jobs/5 lpa Jobs</a>
              <a class="flink col-lg-3" href="/scholarships-jobs-vacancies" target="noopener">Scholarships Jobs</a>
              <a class="flink col-lg-3" href="/tech-support-jobs-vacancies" target="noopener">Tech Support Jobs</a>
              <a class="flink col-lg-3" href="/research-jobs-vacancies" target="noopener">Research Jobs</a>
              <a class="flink col-lg-3" href="/logistics---transportation-jobs-vacancies" target="noopener">Logistics / Transport Jobs</a>
              <a class="flink col-lg-3" href="/diploma-jobs" target="noopener">Diploma Jobs</a>
              <a class="flink col-lg-3" href="/1-to-3-yr-exp-jobs-vacancies" target="noopener">1 to 3 Yr Exp Jobs</a>
              <a class="flink col-lg-3" href="/maintenance-jobs-vacancies" target="noopener">Maintenance Jobs</a>
              <a class="flink col-lg-3" href="/startup-jobs-vacancies" target="noopener">StartUp Jobs</a>
              <a class="flink col-lg-3" href="/bsc-bca-bbm-jobs-vacancies" target="noopener">BSc/BCA/BBM Jobs</a>
              <a class="flink col-lg-3" href="/apprenticeship-jobs-vacancies" target="noopener">Apprenticeship Jobs</a>
              <a class="flink col-lg-3" href="/analyst---analytics-jobs-vacancies" target="noopener">Analyst / Analytics Jobs</a>
              <a class="flink col-lg-3" href="/hospitality-jobs-vacancies" target="noopener">Hospitality Jobs</a>
              <a class="flink col-lg-3" href="/multimedia-jobs-vacancies" target="noopener">Multimedia Jobs</a>
              <a class="flink col-lg-3" href="/pharma-jobs-vacancies" target="noopener">Pharma Jobs</a>
              <a class="flink col-lg-3" href="/quality-control-jobs-vacancies" target="noopener">Quality Control Jobs</a>
              <a class="flink col-lg-3" href="/hire-and-train-jobs-vacancies" target="noopener">Hire and Train Jobs</a>
              <a class="flink col-lg-3" href="/retail-jobs-vacancies" target="noopener">Retail Jobs</a>
              <a class="flink col-lg-3" href="/teaching-jobs-vacancies" target="noopener">Teaching Jobs</a>
              <a class="flink col-lg-3" href="/manpower-consultants-jobs-vacancies" target="noopener">Manpower Consultants Jobs</a>
              <a class="flink col-lg-3" href="/sports-jobs-vacancies" target="noopener">Sports Jobs</a>
              <a class="flink col-lg-3" href="/office-assistant-jobs-vacancies" target="noopener">Office Assistant Jobs</a>
              <a class="flink col-lg-3" href="/journalism-jobs-vacancies" target="noopener">Journalism Jobs</a>
            </b-collapse>
          </p>

          <!-- View More/Less button -->
          <div class="text-center mt-3">
            <p v-b-toggle.moreCategories @click="toggleCategories">
              {{ showMoreCategories ? 'View Less' : 'View More Categories' }}
              <i class="fas" :class="showMoreCategories ? 'fa-chevron-up' : 'fa-chevron-down'"></i>
            </p>
          </div>
        </div>
        <div class="footer-section">
          <h3><a href="/jobs-by-roles" target="noopener" style="color:#333 !important;"><strong>Jobs by Role</strong></a></h3>
          <p class="card-text row m-0">
            <!-- Initial visible roles -->
            <a class="flink col-lg-3" href="/it-software-engineer-jobs-vacancies" target="noopener">IT Software-Engineer Jobs</a>
            <a class="flink col-lg-3" href="/engineer-(core,-non-it)-jobs-vacancies" target="noopener">Engineer (Core, Non-IT) Jobs</a>
            <a class="flink col-lg-3" href="/doctor-physician-jobs-vacancies" target="noopener">Doctor / Physician Jobs</a>
            <a class="flink col-lg-3" href="/delivery-executive-jobs-vacancies" target="noopener">Delivery Executive Jobs</a>
            <a class="flink col-lg-3" href="/sales-marketing-executive-jobs-vacancies" target="noopener">Sales and Marketing Jobs</a>
            <a class="flink col-lg-3" href="/customer-service-tech-support-jobs-vacancies" target="noopener">Customer Support Jobs</a>
            <a class="flink col-lg-3" href="/nurse-healthcare-jobs-vacancies" target="noopener">Nurse / Healthcare Jobs</a>
            <a class="flink col-lg-3" href="/pharmacist-medical-rep-jobs-vacancies" target="noopener"> Medical / Pharma Jobs</a>
            <a class="flink col-lg-3" href="/bpo-telecaller-jobs-vacancies" target="noopener">BPO / Telecaller Jobs</a>
            <a class="flink col-lg-3" href="/hr-admin-jobs-vacancies" target="noopener">HR / Admin Jobs</a>
            <a class="flink col-lg-3" href="/retail-store-executive-jobs-vacancies" target="noopener">Retail Executive Jobs</a>
            <a class="flink col-lg-3" href="/receptionist-front-office-jobs-vacancies" target="noopener">Front Office Jobs</a>
            <a class="flink col-lg-3" href="/data-entry-back-office-jobs-vacancies" target="noopener">Data Entry /Back Office Jobs</a>
            <a class="flink col-lg-3" href="/customer-service-tech-support-jobs-vacancies" target="noopener">Teacher / Trainer Jobs</a>
            <a class="flink col-lg-3" href="/accountant-jobs-vacancies" target="noopener">Accountant Jobs</a>
            <a class="flink col-lg-3" href="/seo-social-media-jobs-vacancies" target="noopener">SEO / Social Media Jobs</a>

            <!-- Collapsible section -->
            <b-collapse id="moreRoles" class="mt-0 mx-0 row mb-3">
              <a class="flink col-lg-3" href="/content-writer--jobs-vacancies" target="noopener">Content Writer Jobs</a>
              <a class="flink col-lg-3" href="/beautician-spa-jobs-vacancies" target="noopener">Beautician / Spa Jobs</a>
              <a class="flink col-lg-3" href="/it---mobile-developer-jobs-vacancies" target="noopener">IT - Mobile Developer Jobs</a>
              <a class="flink col-lg-3" href="/steward-hospitality-jobs-vacancies" target="noopener">Steward / Hospitality Jobs</a>
              <a class="flink col-lg-3" href="/it-hardware-engineer-jobs-vacancies" target="noopener">IT Hardware Engineer Jobs</a>
              <a class="flink col-lg-3" href="/counsellor-jobs-vacancies" target="noopener">Counsellor Jobs</a>
              <a class="flink col-lg-3" href="/design-animation-jobs-vacancies" target="noopener">Design / Animation Jobs</a>
              <a class="flink col-lg-3" href="/architect-jobs-vacancies" target="noopener">Architect Jobs</a>
              <a class="flink col-lg-3" href="/research-jrf-srf-jobs-vacancies" target="noopener">Research/JRF/SRF Jobs</a>
              <a class="flink col-lg-3" href="/fashion-designer-jobs-vacancies" target="noopener">Fashion designer Jobs</a>
              <a class="flink col-lg-3" href="/mechanic-fitter-production-jobs-vacancies" target="noopener">Fitter / Mechanic Jobs</a>
              <a class="flink col-lg-3" href="/management-trainee-jobs-vacancies" target="noopener">Management Trainee Jobs</a>
              <a class="flink col-lg-3" href="/chef-cook-jobs-vacancies" target="noopener">Chef / Cook Jobs</a>
              <a class="flink col-lg-3" href="/others-jobs-vacancies" target="noopener">Others Jobs</a>
              <a class="flink col-lg-3" href="/media-journalism-events-jobs-vacancies" target="noopener">Media & Journalism Jobs</a>
            </b-collapse>
          </p>

          <!-- View More/Less button -->
          <div class="text-center mt-3">
            <p v-b-toggle.moreRoles @click="toggleRoles">
              {{ showMoreRoles ? 'View Less' : 'View More Roles' }}
              <i class="fas" :class="showMoreRoles ? 'fa-chevron-up' : 'fa-chevron-down'"></i>
            </p>
          </div>
        </div>
        <div class="footer-section">
          <h3><a href="/jobs-by-courses" target="noopener" style="color:#333 !important;"><strong>Jobs by Course</strong></a></h3>
          <p class="card-text row m-0">
            <!-- Initial visible courses -->
            <a class="flink col-lg-3" href="/be-b-tech-jobs" target="noopener">BE/B.Tech Jobs</a>
            <a class="flink col-lg-3" href="/msc-jobs" target="noopener">MSc Jobs</a>
            <a class="flink col-lg-3" href="/any-graduate-jobs" target="noopener">Any Graduate Jobs</a>
            <a class="flink col-lg-3" href="/bed-jobs" target="noopener">BEd Jobs</a>
            <a class="flink col-lg-3" href="/mba-pgdm-jobs" target="noopener">MBA/PGDMS Jobs</a>
            <a class="flink col-lg-3" href="/bca-jobs" target="noopener">BCA Jobs</a>
            <a class="flink col-lg-3" href="/b-com-jobs" target="noopener">B.Com Jobs</a>
            <a class="flink col-lg-3" href="/bba-bbm-jobs" target="noopener">BBA/BBM Jobs</a>
            <a class="flink col-lg-3" href="/mca-jobs" target="noopener">MCA Jobs</a>
            <a class="flink col-lg-3" href="/bsc-jobs" target="noopener">BSc Jobs</a>
            <a class="flink col-lg-3" href="/bams-jobs" target="noopener">BAMS Jobs</a>
            <a class="flink col-lg-3" href="/b-pharm-jobs" target="noopener">B.Pharm Jobs</a>
            <a class="flink col-lg-3" href="/me-m-tech-jobs" target="noopener">ME/M.Tech Jobs</a>
            <a class="flink col-lg-3" href="/diploma-jobs" target="noopener">Diploma Jobs</a>
            <a class="flink col-lg-3" href="/ba-jobs" target="noopener">BA Jobs</a>
            <a class="flink col-lg-3" href="/any-post-graduate-jobs" target="noopener">Any Post Graduate Jobs</a>

            <!-- Collapsible section -->
            <b-collapse id="moreCourses" class="mt-0 mx-0 row mb-3">
              <a class="flink col-lg-3" href="/ma-jobs" target="noopener">MA Jobs</a>
              <a class="flink col-lg-3" href="/ca-jobs" target="noopener">CA Jobs</a>
              <a class="flink col-lg-3" href="/llb-jobs" target="noopener">LLB Jobs</a>
              <a class="flink col-lg-3" href="/md-jobs" target="noopener">MD Jobs</a>
              <a class="flink col-lg-3" href="/bds-jobs" target="noopener">BDS Jobs</a>
              <a class="flink col-lg-3" href="/certificate-course-iti-jobs" target="noopener">ITI Jobs</a>
              <a class="flink col-lg-3" href="/mds-jobs" target="noopener">MDS Jobs</a>
              <a class="flink col-lg-3" href="/ms-jobs" target="noopener">MS Jobs</a>
              <a class="flink col-lg-3" href="/10th-pass-ssc-jobs" target="noopener">10th Pass (SSC) Jobs</a>
              <a class="flink col-lg-3" href="/other-post-graduate-jobs" target="noopener">Other Post Graduate Jobs</a>
              <a class="flink col-lg-3" href="/cs-jobs" target="noopener">CS Jobs</a>
              <a class="flink col-lg-3" href="/b-arch-jobs" target="noopener">B.Arch Jobs</a>
              <a class="flink col-lg-3" href="/bams-jobs" target="noopener">BAMS Jobs</a>
              <a class="flink col-lg-3" href="/pg-diploma-jobs" target="noopener">PG Diploma Jobs</a>
              <a class="flink col-lg-3" href="/mbbs-jobs" target="noopener">MBBS Jobs</a>
              <a class="flink col-lg-3" href="/b-design-jobs" target="noopener">B.Design Jobs</a>
              <a class="flink col-lg-3" href="/b-f-scfisheries-jobs" target="noopener">B.F.Sc(Fisheries) Jobs</a>
              <a class="flink col-lg-3" href="/bhm-jobs" target="noopener">BHM Jobs</a>
              <a class="flink col-lg-3" href="/icwa-jobs" target="noopener">ICWA Jobs</a>
              <a class="flink col-lg-3" href="/med-jobs" target="noopener">MEd Jobs</a>
              <a class="flink col-lg-3" href="/b-fashiontech-jobs" target="noopener">B.FashionTech Jobs</a>
              <a class="flink col-lg-3" href="/bhms-jobs" target="noopener">BHMS Jobs</a>
              <a class="flink col-lg-3" href="/llm-jobs" target="noopener">LLM Jobs</a>
              <a class="flink col-lg-3" href="/m-com-jobs" target="noopener">M.Com Jobs</a>
              <a class="flink col-lg-3" href="/b-p-ed-jobs" target="noopener">B.P.Ed Jobs</a>
              <a class="flink col-lg-3" href="/bsw-jobs" target="noopener">BSW Jobs</a>
              <a class="flink col-lg-3" href="/m-phil---ph-d-jobs" target="noopener">M Phil / Ph.D Jobs</a>
              <a class="flink col-lg-3" href="/msw-jobs" target="noopener">MSW Jobs</a>
              <a class="flink col-lg-3" href="/bfa-jobs" target="noopener">BFA Jobs</a>
              <a class="flink col-lg-3" href="/bvsc-jobs" target="noopener">BVSc Jobs</a>
              <a class="flink col-lg-3" href="/m-arch-jobs" target="noopener">M.Arch Jobs</a>
              <a class="flink col-lg-3" href="/m-pharm-jobs" target="noopener">M.Pharm Jobs</a>
            </b-collapse>
          </p>

          <!-- View More/Less button -->
          <div class="text-center mt-3">
            <p v-b-toggle.moreCourses @click="toggleCourses">
              {{ showMoreCourses ? 'View Less' : 'View More Courses' }}
              <i class="fas" :class="showMoreCourses ? 'fa-chevron-up' : 'fa-chevron-down'"></i>
            </p>
          </div>
        </div>
        <div class="footer-section">
          <h3><a href="/jobs-by-branch" target="noopener" style="color:#333 !important;"><strong>Jobs by Branch</strong></a></h3>
          <p class="card-text row m-0">
            <!-- Initial visible branches -->
            <a class="flink col-lg-3" href="/be-b-tech-aeronautical-avionics-aerospace-engineering-jobs" target="noopener" title="Aeronautical Jobs">Aeronautical Engineering Jobs</a>
            <a class="flink col-lg-3" href="/be-b-tech-chemical-engineering-jobs" target="noopener" title="Chemical Engineering Jobs">Chemical Engineering Jobs</a>
            <a class="flink col-lg-3" href="/be-b-tech-electronics-instrumentation-engineering-jobs" target="noopener" title="Eletronics Instrumentation Jobs">Electronics  Instrumentation  Jobs</a>
            <a class="flink col-lg-3" href="/10th-pass-ssc-10thpass-jobs" target="noopener" title="10thpass Jobs">10th Pass Jobs</a>
            <a class="flink col-lg-3" href="/be-b-tech-architecture-engineering-jobs" target="noopener" title="Architecture Jobs">Architecture Engineering Jobs</a>
            <a class="flink col-lg-3" href="/be-b-tech-civil-engineering-jobs" target="noopener" title="Civil Engineering Jobs">Civil Engineering Jobs</a>
            <a class="flink col-lg-3" href="/be-b-tech-mechanical-engineering-jobs" target="noopener" title="Mechanical Jobs">Mechanical Engineering Jobs</a>
            <a class="flink col-lg-3" href="/12th-pass-hse-12thpass-jobs" target="noopener" title="12thpass Jobs">12th Pass Jobs</a>
            <a class="flink col-lg-3" href="/be-b-tech-automobile-engineering-jobs" target="noopener" title="Automobile Jobs">Automobile Engineering Jobs</a>
            <a class="flink col-lg-3" href="/mba-pgdm-banking-finance-jobs" target="noopener" title="Banking Finance Jobs">Banking & Finance Jobs</a>
            <a class="flink col-lg-3" href="/bsc-nursing-jobs" target="noopener" title="Nursing Jobs">Nursing Jobs</a>
            <a class="flink col-lg-3" href="/bsc-information-technology-jobs" target="noopener" title="Information Technology Jobs">IT Jobs (BSc)</a>
            <a class="flink col-lg-3" href="/be-b-tech-computer-science-engineering-cse-jobs" target="noopener" title="Computer Science Jobs">Computer Science Jobs</a>
            <a class="flink col-lg-3" href="/be-b-tech-electrical-engineering-jobs" target="noopener" title="Electrical Engineering Jobs">Electrical Engineering Jobs</a>
            <a class="flink col-lg-3" href="/bsc-physics-applied-physics-jobs" target="noopener" title="BSC Physics Jobs">BSC Physics Jobs</a>
            <a class="flink col-lg-3" href="/mba-pgdm-international-marketing-jobs" target="noopener" title="Marketing Jobs">Marketing Jobs</a>

            <!-- Collapsible section -->
            <b-collapse id="moreBranches" class="w-100 mt-0 mx-0 row mb-3">
              <a class="flink col-lg-3" href="/ba-business-management-jobs" target="noopener" title="Business Management Jobs">Business Management Jobs-BA</a>
              <a class="flink col-lg-3" href="/ba-economics-jobs" target="noopener" title="Economics Jobs">Economics Jobs-BA</a>
              <a class="flink col-lg-3" href="/me-m-tech-advanced-computing-jobs" target="noopener" title="Advanced computing Jobs">Advanced Computing Jobs</a>
              <a class="flink col-lg-3" href="/diploma-bio-informatics-jobs" target="noopener" title="Bio-Informatics Jobs">Bio-Informatics Jobs-Diploma</a>
              <a class="flink col-lg-3" href="/be-b-tech-electronics-communication-engineeringece-jobs" target="noopener" title="ECE Jobs">ECE Jobs</a>
              <a class="flink col-lg-3" href="/bfa-fine-arts-jobs" target="noopener" title="Fine Arts Jobs">Fine Arts Jobs-BFA</a>
              <a class="flink col-lg-3" href="/be-b-tech-fashion-design-technology-jobs" target="noopener" title="Fashion / Design Technology Jobs">Fashion Design Jobs</a>
              <a class="flink col-lg-3" href="/mba-pgdm-international-marketing-jobs" target="noopener" title="International Marketing Jobs">International Marketing Jobs</a>
              <a class="flink col-lg-3" href="/ma-accountancy-jobs" target="noopener" title="Accountancy Jobs">Accountancy Jobs-MA</a>
              <a class="flink col-lg-3" href="/mba-pgdm-administration-jobs" target="noopener" title="Administration Jobs">Administration Jobs-MBA/PGDM</a>
              <a class="flink col-lg-3" href="/mba-pgdm-advertising-mass-communication-jobs" target="noopener" title="Advertising jobs">Mass Communication Jobs</a>
              <a class="flink col-lg-3" href="/llb-law-jobs" target="noopener" title="Law Jobs-LLB">Law Jobs-LLB</a>
              <!-- Continue with remaining branches -->
              <a class="flink col-lg-3" href="/ca-accounts-jobs" target="noopener" title="Accounts Jobs">Accounts Jobs-CA</a>
              <a class="flink col-lg-3" href="/bsc-bioinformatics-jobs" target="noopener" title="BioInformatics Jobs">BioInformatics Jobs-BSc</a>
              <a class="flink col-lg-3" href="/bsc-agriculture-jobs" target="noopener" title="Advertising / Mass Communication Jobs">Agriculture Jobs-BSc</a>
              <a class="flink col-lg-3" href="/mba-pgdm-general-management-jobs" target="noopener" title="General Management Jobs">General Management Jobs</a>
              <!-- Add remaining branches with their respective titles -->
              <a class="flink col-lg-3" href="/be-b-tech-agricultural-irrigation-engineering-jobs" target="noopener" title="Agricultural jobs">Agriculture Engg Jobs</a>
              <a class="flink col-lg-3" href="/bsc-geology-jobs" target="noopener" title="Geology Jobs">Geology Jobs-BSc</a>
              <a class="flink col-lg-3" href="/bsc-physics-applied-physics-jobs" target="noopener" title="Physics / Applied Physics Jobs">Physics Jobs (BSc)</a>
              <a class="flink col-lg-3" href="/ba-politics-jobs" target="noopener" title="Politics Jobs">Politics Jobs-BA</a>
              <a class="flink col-lg-3" href="/bsc-bio-chemistry-jobs" target="noopener" title="Bio-Chemistry Jobs">Bio-Chemistry Jobs-BSc</a>
              <a class="flink col-lg-3" href="/ba-humanities-jobs" target="noopener" title="Humanities Jobs">Humanities Jobs-BA</a>
              <a class="flink col-lg-3" href="/b-fashiontech-apparel-production-jobs" target="noopener" title="Apparel Production Jobs">Apparel Production Jobs</a>
              <a class="flink col-lg-3" href="/diploma-marine-engineering-jobs" target="noopener" title="Marine Engineering Jobs">Marine Engineering Jobs</a>
              <a class="flink col-lg-3" href="/ba-business-economics-jobs" target="noopener" title="Business Economics Jobs">Business Economics Jobs-BA</a>
              <a class="flink col-lg-3" href="/mba-pgdm-human-resources-jobs" target="noopener" title="Human Resourse Jobs">HR Jobs (MBA)</a>
              <a class="flink col-lg-3" href="/be-b-tech-applied-electronics-jobs" target="noopener" title="Applied Electronics Jobs">Applied Electronics Jobs</a>
              <a class="flink col-lg-3" href="/bsw-social-work-jobs" target="noopener" title="Social Work Jobs">Social Work Jobs-BSW</a>
              <a class="flink col-lg-3" href="/b-com-commerce-jobs" target="noopener" title="Commerce Jobs">Commerce Jobs-B.Com</a>
              <a class="flink col-lg-3" href="/bhm-hotel-management-jobs" target="noopener" title="Hotel Management Jobs">Hotel Management Jobs-BHM</a>
              <a class="flink col-lg-3" href="/be-b-tech-industrial-engineering-jobs" target="noopener" title="Industrial Engineering Jobs">Industrial Engineering Jobs</a>
              <a class="flink col-lg-3" href="/bsc-nursing-jobs" target="noopener" title="Nursing Jobs">Nursing Jobs-BSc</a>
            </b-collapse>
          </p>

          <!-- View More/Less button -->
          <div class="text-center mt-3">
            <p v-b-toggle.moreBranches @click="toggleBranches">
              {{ showMoreBranches ? 'View Less Branches' : 'View More Branches' }}
              <i class="fas" :class="showMoreBranches ? 'fa-chevron-up' : 'fa-chevron-down'"></i>
            </p>
          </div>
        </div>
      </div>
    </div>
    <div class="footer">
      <div class="container p-3">
        <div class="row">
          <div class="col-lg-5 col-md-12  alignmob">
            <p class="content-center mb-0" v-if="this.year">© {{year}} Talentmap Technologies Pvt Ltd</p>

            <!-- <p class="content-center mb-0" v-if="this.year">© {{year}} <a href="/" style="color:#ffff">Hireclap</a> | Hire best matching candidates</p> -->
          </div>
          <div class="col-lg-4 col-md-6  alignmob">
            <p class="content-center mb-0"><small class="mb-0"><a href="/privacy" target="noopener" class="flink text-decoration-none">Privacy Policy </a>|<a href="/terms" target="noopener" class="flink text-decoration-none"> Terms &amp; Conditions</a></small></p>
          </div>
          <div class="col-lg-3 col-md-6 alignmob">
            <a href="https://www.facebook.com/Hireclap" aria-label="facebook" target="noopener">
              <v-icon class="mdi-footer">{{ $icons.facebook }}</v-icon>
            </a>
            <a href="https://twitter.com/hireclap" aria-label="twitter" target="noopener">
              <v-icon class="mdi-footer">{{ $icons.twitter}}</v-icon>
            </a>
            <a href="https://www.linkedin.com/company/hireclap" aria-label="linkedin" target="noopener">
              <v-icon class="mdi-footer">{{ $icons.linkedin}}</v-icon>
            </a>
            <a href="https://www.youtube.com/channel/UC_Rhjfe3TniDTGLn8nxcu0Q" aria-label="youtube" target="noopener">
              <v-icon class="mdi-footer">{{ $icons.youtube}}</v-icon>
            </a>
            <a href="https://www.instagram.com/hireclap" aria-label="instagram" target="noopener">
              <v-icon class="mdi-footer">{{ $icons.instagram}}</v-icon>
            </a>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Actions from '../libraries/apiActions.js';
import '../assets/hire.css';
export default {
  name: "App-footer",
  data(){
    return{
      action: new Actions(),
      year:null,
      showMoreCities: false,
      showMoreCategories: false,
      showMoreRoles: false,
      showMoreCourses: false,
      showMoreBranches: false
    }
  },
  beforeMount(){
    this.year = new Date().getFullYear();
  },
  methods: {
    toggleCities() {
      this.showMoreCities = !this.showMoreCities;
    },
    toggleCategories() {
      this.showMoreCategories = !this.showMoreCategories;
    },
    toggleRoles() {
      this.showMoreRoles = !this.showMoreRoles;
    },
    toggleCourses() {
      this.showMoreCourses = !this.showMoreCourses;
    },
    toggleBranches() {
      this.showMoreBranches = !this.showMoreBranches;
    }
  }
}
</script>
<style>
.footerBtn {border: 1px solid #0054ad;color: #0054ad;}.footerBtn:hover{color: #212529}
.footer-section h3 a{
    color: #1a1a1a;
    font-size: 1.25rem;
    margin-bottom: 1.5rem;
    font-weight: 600;
}
</style>